import React from "react";
import {
  Stepper as MuiStepper,
  Step,
  StepLabel,
  Box,
  Typography,
} from "@mui/material";
import Button from "../Button";

const Stepper = ({
  steps = [],
  activeStep,
  setActiveStep,
  onFinish,
  showControls = true,
  onBack,
  onNext,
  nextButtonDisable = false,
  backBtnText = "Prev",
  sx = {},
  className = "",
  contentClassName = "",
}) => {
  const handleNext = async () => {
    // last step
    if (activeStep === steps.length - 1) {
      // const canFinish = onFinish ? onFinish() : true;
      onFinish && onFinish();
      // if (canFinish !== false) {
      //   setActiveStep((prev) => prev + 1);
      // }
      return;
    }

    // validate current step
    const canMove = onNext ? await onNext() : true;

    // ❌ block step change
    if (canMove === false) return;

    // ✅ move next
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
    onBack && onBack();
  };

  const CurrentContent = steps[activeStep]?.component;

  return (
    <Box width="100%" className={`stepper-box-container ${className ?? ""}`}>
      {/* Top Stepper */}
      <Box className="stepper-main-box-container">
        {showControls && (
          <Button
            size="sm"
            hierarchy={{ type: "tertiaryGrey", buttonText: backBtnText }}
            disable={activeStep === 0}
            onClick={handleBack}
          />
        )}
        <MuiStepper
          activeStep={activeStep}
          sx={{ ...sx }}
          className="stepper-container"
        >
          {steps.map((step, idx) => (
            <Step key={idx} className="stepper-step">
              <StepLabel className="stepper-step-label">{step.label}</StepLabel>
            </Step>
          ))}
        </MuiStepper>
        {showControls && (
          <Button
            size="sm"
            hierarchy={{
              type: "primary",
              buttonText: activeStep === steps.length - 1 ? "Finish" : "Next",
            }}
            disable={activeStep === steps.length - 1 && nextButtonDisable}
            onClick={handleNext}
          />
        )}
      </Box>
      {/* Step Body */}
      <Box
        sx={{ minHeight: 200 }}
        className={`stepper-content-box-container ${contentClassName ?? ""}`}
      >
        {CurrentContent ? (
          CurrentContent
        ) : (
          <Typography className="stepper-no-content-text">
            No content found
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Stepper;
